"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CachesController", {
    enumerable: true,
    get: function() {
        return CachesController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _cachesservice = require("~/services/caches.service");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let CachesController = class CachesController {
    async cacheGet(_, res) {
        const data = await this.cachesService.cacheGet();
        res.set({
            'Content-Type': 'application/json',
            'Content-Disposition': `attachment; filename="cache-export.json"`
        });
        return JSON.stringify(data);
    }
    async cacheDelete() {
        return await this.cachesService.cacheDelete();
    }
    constructor(cachesService){
        this.cachesService = cachesService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/cache',
        '/api/v2/meta/cache'
    ]),
    (0, _extractidsmiddleware.Acl)('cacheGet', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], CachesController.prototype, "cacheGet", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/cache',
        '/api/v2/meta/cache'
    ]),
    (0, _extractidsmiddleware.Acl)('cacheDelete', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], CachesController.prototype, "cacheDelete", null);
CachesController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _cachesservice.CachesService === "undefined" ? Object : _cachesservice.CachesService
    ])
], CachesController);
